import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateVacancy = {
  updateVacancy: { data: null, loading: false, error: null },
};

export const updateVacancy = createAsyncThunk('user/updateVacancy', async ({ id, ...data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateVacancy = {
  [updateVacancy.pending]: (state) => {
    state.updateVacancy.loading = true;
    state.updateVacancy.error = null;
  },
  [updateVacancy.fulfilled]: (state, action) => {
    state.updateVacancy.loading = false;
    state.updateVacancy.data = action.payload;
    state.updateVacancy.error = null;
  },
  [updateVacancy.rejected]: (state, action) => {
    state.updateVacancy.loading = false;
    state.updateVacancy.error = action.payload;
  },
};
